<div class="summary-modal-container">
  <div class='summary-modal-close' (click)='close()'>
    <!-- SVG for close button -->
    <svg xmlns="http://www.w3.org/2000/svg" width='16' height='16'
          viewBox="0 0 16 16">
      <defs>
        <style>.cls-1 {
          fill: #d0d5d6;
        }

        .cls-2 {
          fill: none;
        }</style>
      </defs>
      <g>
        <g>
          <rect class="cls-1" x="4" y="4" width="1" height="1"/>
          <rect class="cls-1" x="3" y="3" width="1" height="1"/>
          <rect class="cls-1" x="5" y="5" width="1" height="1"/>
          <rect class="cls-1" x="6" y="6" width="1" height="1"/>
          <rect class="cls-1" x="7" y="7" width="1" height="1"/>
          <rect class="cls-1" x="7" y="7" width="1" height="1"/>
          <rect class="cls-1" x="8" y="8" width="1" height="1"/>
          <rect class="cls-1" x="9" y="9" width="1" height="1"/>
          <rect class="cls-1" x="10" y="10" width="1" height="1"/>
          <rect class="cls-1" x="11" y="11" width="1" height="1"/>
          <rect class="cls-1" x="12" y="12" width="1" height="1"/>
          <rect class="cls-1" x="4" y="11" width="1" height="1"
                transform="translate(-7 16) rotate(-90)"/>
          <rect class="cls-1" x="3" y="12" width="1" height="1"
                transform="translate(-9 16) rotate(-90)"/>
          <rect class="cls-1" x="5" y="10" width="1" height="1"
                transform="translate(-5 16) rotate(-90)"/>
          <rect class="cls-1" x="6" y="9" width="1" height="1"
                transform="translate(-3 16) rotate(-90)"/>
          <rect class="cls-1" x="7" y="8" width="1" height="1"
                transform="translate(-1 16) rotate(-90)"/>
          <rect class="cls-1" x="7" y="8" width="1" height="1"
                transform="translate(-1 16) rotate(-90)"/>
          <rect class="cls-1" x="8" y="7" width="1" height="1"
                transform="translate(1 16) rotate(-90)"/>
          <rect class="cls-1" x="9" y="6" width="1" height="1"
                transform="translate(3 16) rotate(-90)"/>
          <rect class="cls-1" x="10" y="5" width="1" height="1"
                transform="translate(5 16) rotate(-90)"/>
          <rect class="cls-1" x="11" y="4" width="1" height="1"
                transform="translate(7 16) rotate(-90)"/>
          <rect class="cls-1" x="12" y="3" width="1" height="1"
                transform="translate(9 16) rotate(-90)"/>
          <rect class="cls-2" width="16" height="16"/>
        </g>
      </g>
    </svg>
  </div>
  <div class="summary-modal-content modal-bg-dark">
    <div class="flex">
      <div class="summary-selected-column">
        <div class='summary-modal-title'>Подтемы</div>
      </div>
      <div class="flex-fill"></div>
      <div class="flex-fill"></div>
    </div>
    <div class="flex flex_nowrap summary-modal-main-content">
      <div class="summary-selected-column">
        <div class='summary-selected-table-rows'>
          <div class='summary-selected-table-rows--item flex'
                *ngFor='let file of selectedFiles; let idx = index;'>
            <div
              class='summary-selected-table-rows--text flex-fill'>{{ file.str_title }}
            </div>
            <a class='flex-min summary-selected-table-rows--cmd'
                href='javascript:;' (click)='removeFile(idx)'>
              <!-- SVG Для удаления элемента из выбранных -->
              <svg xmlns="http://www.w3.org/2000/svg"
                    width="16" height="16"
                    viewBox="0 0 16 16">
                <defs>
                  <style>.cls-remove-1 {
                    fill: #465561;
                  }

                  .cls-remove-2 {
                    fill: none;
                  }</style>
                </defs>
                <g>
                  <g>
                    <rect class="cls-remove-1" x="7.5" y="7.5" width="1" height="4"
                          transform="translate(-1.5 17.5) rotate(-90)"/>
                    <rect class="cls-remove-2" width="16" height="16"/>
                    <path class="cls-remove-1"
                          d="M10,3V2A1,1,0,0,0,9,1H7A1,1,0,0,0,6,2V3H1V4H15V3ZM7,3V2H9V3Z"/>
                    <polygon class="cls-remove-1"
                              points="12 14 4 14 4 5 3 5 3 15 13 15 13 5 12 5 12 14"/>
                  </g>
                </g>
              </svg>
            </a>
          </div>
        </div>

        <button (click)='save()' class='button-accept'>OK</button>
      </div>
      <div class="summary-available-column">
        <div class='summary-available-table-rows'>
          <div class='flex summary-available-table-rows--item'
                *ngFor='let file of filteredFiles'
                (click)='selectFile(file)'>
            <a class='summary-available-table-rows--icon'
                *ngIf='!isFileSelected(file)'>
              <!-- SVG: Select arrow -->
              <svg xmlns="http://www.w3.org/2000/svg"
                    width='16' height='16'
                    viewBox="0 0 16 16">
                <defs>
                  <style>.cls-arrow-1, .cls-arrow-2 {
                    fill: none;
                  }

                  .cls-arrow-2 {
                    stroke: #6e95c8;
                    stroke-miterlimit: 10;
                  }

                  .cls-arrow-3 {
                    fill: #6e95c8;
                  }</style>
                </defs>
                <g>
                  <g>
                    <rect class="cls-arrow-1" width="16" height="16"/>
                    <line class="cls-arrow-2" x1="13" y1="8" x2="6" y2="8"/>
                    <polygon class="cls-arrow-3"
                              points="6.5 11.5 3 8 6.5 4.5 6.5 11.5"/>
                  </g>
                </g>
              </svg>
            </a>
            <div
              class='summary-available-table-rows--icon-placeholder'>
            </div>
            <div
              class='flex-fill summary-available-table-rows--text'>{{ file.str_title }}
            </div>
          </div>
        </div>
      </div>
      <div class="flex-fill summary-search-form-column">
        <div class='summary-search-form-column--wrapper'>
          <div class="title">Название</div>
          <div class="search">
            <form>
              <input type="text"
                      placeholder="сложение с переходом через десяток..."
                      [(ngModel)]="titleString"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="processTitleSearch()">
              <button (click)="processTitleSearch()">
                <svg xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16">
                  <defs>
                    <style>.cls-search-1 {
                      fill: #afafaf;
                    }

                    .cls-search-2 {
                      fill: none;
                    }</style>
                  </defs>
                  <g>
                    <g>
                      <path class="cls-search-1"
                            d="M6,2A4,4,0,1,1,2,6,4,4,0,0,1,6,2M6,1a5,5,0,1,0,5,5A5,5,0,0,0,6,1Z"/>
                      <path class="cls-search-1"
                            d="M14.36,14.64h0a1.27,1.27,0,0,1-1.79-.07L9.78,11.78a.67.67,0,0,1,0-1l.75-.75a.67.67,0,0,1,1,0l2.79,2.79A1.27,1.27,0,0,1,14.36,14.64Z"/>
                      <rect class="cls-search-2" width="16" height="16"/>
                    </g>
                  </g>
                </svg>
              </button>
            </form>
          </div>
          <div class="type">
            <div class="title">Тип</div>
            <ul class="three-col">
              <li *ngFor='let type of objectKeys(exerciseTypes)'>
                <label>
                  <input class="checkbox"
                          type="checkbox"
                          name="checkbox"
                          [value]="type"
                          (change)="toggleType(type)">
                  <span class="checkbox-custom"></span>
                  <span class="checkbox-title">{{ exerciseTypes[type] }}</span>
                </label>
              </li>
            </ul>
          </div>
        </div>
        <div class="themes">
          <div class='summary-search-form-column--wrapper'>
            <div class="title">Темы</div>
            <div class="search">
              <form>
                <input
                  type="text"
                  placeholder=""
                  [(ngModel)]="themeString"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="filterThemes()">
                <button type="submit" (click)="filterThemes()">
                  <svg xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16">
                    <defs>
                      <style>.cls-search-1 {
                        fill: #afafaf;
                      }

                      .cls-search-2 {
                        fill: none;
                      }</style>
                    </defs>
                    <g>
                      <g>
                        <path class="cls-search-1"
                              d="M6,2A4,4,0,1,1,2,6,4,4,0,0,1,6,2M6,1a5,5,0,1,0,5,5A5,5,0,0,0,6,1Z"/>
                        <path class="cls-search-1"
                              d="M14.36,14.64h0a1.27,1.27,0,0,1-1.79-.07L9.78,11.78a.67.67,0,0,1,0-1l.75-.75a.67.67,0,0,1,1,0l2.79,2.79A1.27,1.27,0,0,1,14.36,14.64Z"/>
                        <rect class="cls-search-2" width="16" height="16"/>
                      </g>
                    </g>
                  </svg>
                </button>
              </form>
            </div>
          </div>
          <ul>
            <li *ngFor="let theme of filteredThemes">
              <label>
                <input class="checkbox" type="checkbox" name="checkbox"
                        (change)="toggleTheme(theme)">
                <span class="checkbox-custom"></span>
                <span class="checkbox-title">
                  <span class="number theme_number">{{ theme.number }}</span>{{ theme.title }}
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
  
  